export function getInitialStateReportes() {
   return {
      loginsPorPersona: [],
      tablaUsuarios: [],
      porcentajeUsuariosNivel1Login: {},
      cantidadProspectos: [],
      productos: [],
      porcentajeUsuariosNivel1Poliza: {},
      polizasEmitidas: null,
      polizasAlBroker: null,
      sucursalMasActiva: {},
      usuarioMasActivo: {},
      ingresoPromedio: {},
   };
}

export default getInitialStateReportes();
